module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.closeModal();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent"
  }, [_c('h1', {
    staticClass: "uppercase productShadeTitle"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('form', {
    staticClass: "form_campaing",
    attrs: {
      "enctype": "multipart/form-data",
      "action": ""
    }
  }, [_c('table', [_c('tr', [_c('td', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom EN")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameEN),
      expression: "nameEN"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nameEN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameEN = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom FR")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameFR),
      expression: "nameFR"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nameFR)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameFR = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer boutonSaveDelete"
  }, [_c('button', {
    staticClass: "btn block pointer uppercase save",
    on: {
      "click": function($event) {
        _vm.createComponentType();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("zone.save")))])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f377ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/componentType/CreateComponentType.vue
// module id = 3126
// module chunks = 0